import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function Login() {
  const { t, login } = useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || t.login.error);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16">
      <div className="bg-white flat-border-2 rounded-2xl p-8">
        <h1 className="font-display text-3xl tracking-tight">{t.login.title}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#141414]/60">{t.login.username}</label>
            <input type="text" autoComplete="username" required value={username} onChange={(e) => setUsername(e.target.value)} data-testid="login-username" className="mt-1 w-full flat-border rounded-lg px-3 py-2.5 outline-none" />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#141414]/60">{t.login.password}</label>
            <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1 w-full flat-border rounded-lg px-3 py-2.5 outline-none" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="flat-btn-primary rounded-full px-6 py-2.5 font-semibold text-sm flex items-center gap-2 w-full justify-center">
            <LogIn className="w-4 h-4" strokeWidth={2} /> {loading ? "..." : t.login.submit}
          </button>
        </form>
        <p className="mt-6 text-[11px] text-[#141414]/50">
          Default: <span className="font-mono">admin</span> / <span className="font-mono">lepogete</span>
        </p>
      </div>
    </div>
  );
}
